import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { exchangeSession } from '../services/api';
import { useAuth } from '../context/AuthContext';

// Handles the #session_id=... fragment returned by Emergent Google auth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const finish = () => {
      // clear the fragment then go home
      window.history.replaceState(null, '', window.location.pathname);
      navigate('/', { replace: true });
    };
    if (!sessionId) { finish(); return; }
    exchangeSession(sessionId)
      .then((u) => { setUser(u); })
      .catch(() => { /* ignore */ })
      .finally(finish);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 hero-flames">
      <Loader2 className="w-10 h-10 animate-spin text-white" />
      <p className="text-white font-800">Connexion en cours…</p>
    </div>
  );
};

export default AuthCallback;
